import { AlgoliaSearch } from '../../algolia';
import { BaseHandler } from '../../graphql-orchestrator-link';
import { transformFilters } from './utils/AlgoliaFiltersTransformUtil';
import { transposeAlgoliaHit } from './utils/AppTileTransposeUtil';
export class SearchResultHandler extends BaseHandler {
  async fetchCustom(operation, _transformedOperation, _sequenceConfigValue, _primaryResponse) {
    const {
      algoliaAppId,
      algoliaAppKey,
      algoliaSearchIndex,
      query,
      filters,
      after,
      first
    } = operation.variables;
    const facetFilters = transformFilters(filters);
    const response = await AlgoliaSearch({
      applicationId: algoliaAppId,
      apiKey: algoliaAppKey,
      indexName: algoliaSearchIndex,
      query,
      facetFilters,
      after,
      first
    });
    return response;
  }
  responseTransformer(operation, _transformedOperation, _sequenceConfigValue, _primaryResponse, customResponse) {
    const hits = customResponse === null || customResponse === void 0 ? void 0 : customResponse.results[0].hits;
    const currentPage = (customResponse === null || customResponse === void 0 ? void 0 : customResponse.results[0].page) || 0;
    const totalPages = (customResponse === null || customResponse === void 0 ? void 0 : customResponse.results[0].nbPages) || 0;
    const totalHits = (customResponse === null || customResponse === void 0 ? void 0 : customResponse.results[0].nbHits) || 0;
    const newResponse = {
      marketplaceSearch: {
        __typename: 'AppsConnection',
        pageInfo: {
          __typename: 'AppConnectionPageInfo',
          totalCount: totalHits,
          hasNextPage: currentPage + 1 < totalPages
        },
        edges: hits === null || hits === void 0 ? void 0 : hits.map(hit => transposeAlgoliaHit({
          hit,
          query: operation.variables.query
        }))
      }
    };
    return newResponse;
  }
}